(() => {
  "use strict";
  
  var u = {
    5055: (e, o, t) => {
      var c = t(4873);
      const n = "product-hotspots";
      
      var d = typeof (window.Shopify?.theme?.sections?.registered || {})[n] == "undefined" && 
        (0, c.z2)(n, {
          onLoad() {
            // Get the current section element
            const sectionElement = this.container;
            
            const l = f => {
              const _ = f.target.parentElement;
              // Only query within the current section, not the entire document
              const sectionContainer = _.closest('[data-section-type="product-hotspots"], .shopify-section');
              const hotspotsInSection = sectionContainer.querySelectorAll(".lg-hotspot");
              
              hotspotsInSection.forEach(a => {
                if (a === _) {
                  a.classList.toggle("lg-hotspot--selected");
                  a.offsetLeft <= 10 && a.classList.add("lg-hotspot--left");
                  a.offsetLeft >= 10 && a.classList.remove("lg-hotspot--left");
                } else {
                  a.classList.remove("lg-hotspot--selected");
                  a.offsetLeft <= 10 && a.classList.add("lg-hotspot--left");
                  a.offsetLeft >= 10 && a.classList.remove("lg-hotspot--left");
                }
              });
            };
            
            // Initialize only buttons within this section
            (() => {
              // Query only within the current section
              sectionElement.querySelectorAll(".lg-hotspot__button").forEach(_ => {
                _.addEventListener("click", l);
              });
            })();
          },
          
          onUnload() {
            // Clean up event listeners when section is unloaded
            const sectionElement = this.container;
            sectionElement.querySelectorAll(".lg-hotspot__button").forEach(_ => {
              _.removeEventListener("click", l);
            });
          }
        });
    }
  };
  
  // Rest of the webpack configuration remains the same
  var p = {};
  
  function r(e) {
    var o = p[e];
    if (o !== void 0) return o.exports;
    var t = p[e] = { exports: {} };
    return u[e].call(t.exports, t, t.exports, r), t.exports;
  }
  
  r.m = u;
  
  (() => {
    var e = [];
    r.O = (o, t, c, n) => {
      if (t) {
        n = n || 0;
        for (var s = e.length; s > 0 && e[s - 1][2] > n; s--) e[s] = e[s - 1];
        e[s] = [t, c, n];
        return;
      }
      for (var i = Infinity, s = 0; s < e.length; s++) {
        for (var [t, c, n] = e[s], d = !0, l = 0; l < t.length; l++)
          (n & !1 || i >= n) && Object.keys(r.O).every(g => r.O[g](t[l])) ? 
            t.splice(l--, 1) : (d = !1, n < i && (i = n));
        if (d) {
          e.splice(s--, 1);
          var f = c();
          f !== void 0 && (o = f);
        }
      }
      return o;
    };
  })();
  
  (() => {
    r.d = (e, o) => {
      for (var t in o)
        r.o(o, t) && !r.o(e, t) && Object.defineProperty(e, t, { enumerable: !0, get: o[t] });
    };
  })();
  
  (() => {
    r.o = (e, o) => Object.prototype.hasOwnProperty.call(e, o);
  })();
  
  (() => {
    r.r = e => {
      typeof Symbol != "undefined" && Symbol.toStringTag && 
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
      Object.defineProperty(e, "__esModule", { value: !0 });
    };
  })();
  
  (() => {
    r.j = 154;
  })();
  
  (() => {
    var e = { 154: 0 };
    r.O.j = c => e[c] === 0;
    
    var o = (c, n) => {
      var [s, i, d] = n, l, f, _ = 0;
      for (l in i) r.o(i, l) && (r.m[l] = i[l]);
      if (d) var v = d(r);
      for (c && c(n); _ < s.length; _++)
        f = s[_], r.o(e, f) && e[f] && e[f][0](), e[s[_]] = 0;
      return r.O(v);
    };
    
    var t = globalThis.webpackChunkstarter_theme = globalThis.webpackChunkstarter_theme || [];
    t.forEach(o.bind(null, 0));
    t.push = o.bind(null, t.push.bind(t));
  })();
  
  var b = r.O(void 0, [293], () => r(5055));
  b = r.O(b);
})();